import { type Question } from '@/types'

export const getMatrixRowPosition = (
  questions: Question[],
  rowFormIndex: string
) => {
  for (
    let questionIndex = 0;
    questionIndex < questions?.length;
    questionIndex++
  ) {
    const question = questions?.[questionIndex]

    if (question.question_type?.question_type === 'matrix') {
      const rowIndex = question.question_rows?.findIndex(
        (row) => Number(row.form_index) === Number(rowFormIndex)
      )

      if (rowIndex !== -1) {
        return `${questionIndex + 1}.${rowIndex + 1}`
      }
    }
  }
  return null
}
